import i18next from "i18next";
import { success, custom } from "./utilities";
import { ToastifyService, centerActivityService } from "../../services";
import {
  centerActivityConstants,
  translationConstants,
  globalSystemConstants,
} from "../../constants";
import { getUserPayload } from "../../system";

const gridData = {
  length: 10,
  pageNumber: 1,
  orderBy: "id desc",
  filterQuery: null,
  search: null,
};

const toggleViewModal = (flag) => {
  return (dispatch) =>
    dispatch(success(flag, centerActivityConstants.VIEW_MODAL));
};

export const getActivities = (GetActivityData) => {
  return (dispatch) => {
    const userData = getUserPayload();
    centerActivityService
      .getActivities(GetActivityData, userData.user.centerId)
      .then((response) =>
        dispatch(success(response, centerActivityConstants.ACTIVITY_DATA))
      )
      .catch((error) => ToastifyService.showError(error));
  };
};

export const getActivityById = (id) => {
  return (dispatch) => {
    centerActivityService
      .getActivityById(id)
      .then((response) => {
        dispatch(
          success(response, centerActivityConstants.ACTIVITY_DATA_BY_ID)
        );
      })
      .catch((error) => {
        ToastifyService.showError(i18next.t(translationConstants.noDataFound));
      });
  };
};

export const addActivity = (activityData, gridState) => {
  return (dispatch) => {
    dispatch(
      custom(
        centerActivityConstants.ADD_CENTER_ACTIVITY,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    centerActivityService
      .addActivity(activityData)
      .then((response) => {
        if (response) {
          dispatch(getActivities(gridState));
          ToastifyService.showSuccess(response);
        }
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            centerActivityConstants.ADD_CENTER_ACTIVITY,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const publishActivity = (id, gridState) => {
  return (dispatch) => {
    dispatch(
      custom(
        centerActivityConstants.PUBLISH_CENTER_ACTIVITY,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    centerActivityService
      .publishActivity(id)
      .then((response) => {
        if (response) {
          dispatch(getActivities(gridState));
          ToastifyService.showSuccess(response);
        }
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            centerActivityConstants.PUBLISH_CENTER_ACTIVITY,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const updateActivity = (activityData, gridState) => {
  return (dispatch) => {
    dispatch(
      custom(
        centerActivityConstants.UPDATE_CENTER_ACTIVITY,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    centerActivityService
      .updateActivity(activityData)
      .then((response) => {
        if (response) {
          dispatch(getActivities(gridState));
          ToastifyService.showSuccess(response);
        }
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            centerActivityConstants.UPDATE_CENTER_ACTIVITY,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const updateActivityStatusById = (activityData, id, gridState) => {
  return (dispatch) => {
    dispatch(
      custom(
        centerActivityConstants.UPDATE_CENTER_ACTIVITY_BY_ID,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    centerActivityService
      .updateActivityStatusById(activityData, id)
      .then((response) => {
        if (response) {
          dispatch(getActivities(gridState));
          ToastifyService.showSuccess(response);
        }
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            centerActivityConstants.UPDATE_CENTER_ACTIVITY_BY_ID,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const deleteActivityById = (id) => {
  return (dispatch) => {
    dispatch(
      custom(
        centerActivityConstants.DELETE_CENTER_ACTIVITY,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    centerActivityService
      .deleteActivityById(id)
      .then((response) => {
        if (response) {
          dispatch(getActivities(gridData));
          ToastifyService.showSuccess(response);
        }
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            centerActivityConstants.DELETE_CENTER_ACTIVITY,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};
export const getCalenderEvents = (GetCalenderData , typeFilter) => {
  return (dispatch) => {
    if(typeFilter?.length === 0){
      dispatch(success([], centerActivityConstants.CALENDER_DATA))
      return;
    }
    centerActivityService
      .getCalenderEvents(GetCalenderData)
      .then((response) =>
        dispatch(success(response, centerActivityConstants.CALENDER_DATA))
      )
      .catch((error) => ToastifyService.showError(error))
  };
};
export const centerActivityActions = {
  toggleViewModal,
  getActivities,
  getActivityById,
  addActivity,
  publishActivity,
  updateActivity,
  updateActivityStatusById,
  deleteActivityById,
  getCalenderEvents,
};
